// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file bffuser/v1/setting_model.proto (package bffuser.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { AreaCode } from "../../bfftypes/v1/area_pb";
import { file_bfftypes_v1_area } from "../../bfftypes/v1/area_pb";
import { file_buf_validate_validate } from "../../buf/validate/validate_pb";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file bffuser/v1/setting_model.proto.
 */
export const file_bffuser_v1_setting_model: GenFile = /*@__PURE__*/
  fileDesc("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", [file_bfftypes_v1_area, file_buf_validate_validate, file_google_protobuf_timestamp]);

/**
 * StackOrderItem represents a single entry in the stack order configuration.
 * It associates a generation source type with a display color.
 * Mirrors internalapi.v1.StackOrderItem; the BFF handler converts between them.
 *
 * @generated from message bffuser.v1.StackOrderItem
 */
export type StackOrderItem = Message<"bffuser.v1.StackOrderItem"> & {
  /**
   * Generation source type for this stack order entry. Must not be UNSPECIFIED.
   *
   * @generated from field: bffuser.v1.GenerationSourceTypeForSetting source = 1;
   */
  source: GenerationSourceTypeForSetting;

  /**
   * Hex color code for this source type (e.g. "#1a2b3c").
   * Must match the pattern ^#[0-9a-fA-F]{6}$.
   *
   * @generated from field: string color = 2;
   */
  color: string;
};

/**
 * Describes the message bffuser.v1.StackOrderItem.
 * Use `create(StackOrderItemSchema)` to create a new message.
 */
export const StackOrderItemSchema: GenMessage<StackOrderItem> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_setting_model, 0);

/**
 * PersonalSettings holds the per-member display and operational preferences
 * for the personal settings tab (個人設定).
 * member_id is never exposed to the frontend; the BFF handler derives it from
 * the eauth session.
 *
 * Usage in Update: the strict protovalidate rules below (enum.not_in: [0],
 * stack_order.min_items = 9) require the client to populate every field on
 * every UpdatePersonalSettings call. The companion update_mask in
 * UpdatePersonalSettingsRequest acts as a *change marker* (= "which fields
 * the user just edited"), not a partial-payload selector. The backend
 * usecase still applies only the fields listed in update_mask.
 *
 * TODO(#556): migrate to true FieldMask partial update by adding
 * (buf.validate.field).ignore = IGNORE_IF_DEFAULT_VALUE to the enums and
 * stack_order, and dropping the frontend mergeSettings() helper that
 * currently fills every field. See issue #556 for the cross-layer plan.
 *
 * @generated from message bffuser.v1.PersonalSettings
 */
export type PersonalSettings = Message<"bffuser.v1.PersonalSettings"> & {
  /**
   * @generated from field: bffuser.v1.Theme theme = 1;
   */
  theme: Theme;

  /**
   * @generated from field: bffuser.v1.MonitoringUnit monitoring_unit = 2;
   */
  monitoringUnit: MonitoringUnit;

  /**
   * Whether to show the ticker in the dashboard.
   *
   * @generated from field: bool show_ticker = 3;
   */
  showTicker: boolean;

  /**
   * Business areas the member operates in. 0 to 10 distinct areas.
   * Each element must be a defined non-UNSPECIFIED AreaCode.
   *
   * @generated from field: repeated bfftypes.v1.AreaCode business_areas = 4;
   */
  businessAreas: AreaCode[];

  /**
   * Stack order of generation source types in dashboard charts.
   * Must contain exactly 9 entries, one per GenerationSourceTypeForSetting
   * value (excluding UNSPECIFIED). Each entry specifies source type and color.
   * Specifying this field in update_mask replaces the entire array.
   *
   * @generated from field: repeated bffuser.v1.StackOrderItem stack_order = 5;
   */
  stackOrder: StackOrderItem[];

  /**
   * Optimistic-lock token returned by Get and Update responses. Unix epoch
   * represents settings that have not been persisted yet. Ignored inside the
   * settings message of Update requests; clients send it as expected_updated_at.
   *
   * @generated from field: google.protobuf.Timestamp updated_at = 6;
   */
  updatedAt?: Timestamp;

  /**
   * Which side of the intraday order book is placed on the left
   * (AC-SPS-032 / AC-SPS-033). Must not be UNSPECIFIED.
   *
   * @generated from field: bffuser.v1.OrderBookColumnOrder order_book_column_order = 8;
   */
  orderBookColumnOrder: OrderBookColumnOrder;
};

/**
 * Describes the message bffuser.v1.PersonalSettings.
 * Use `create(PersonalSettingsSchema)` to create a new message.
 */
export const PersonalSettingsSchema: GenMessage<PersonalSettings> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_setting_model, 1);

/**
 * Theme controls the color theme of the application UI.
 * Mirrors internalapi.v1.Theme; the BFF handler converts between them.
 *
 * @generated from enum bffuser.v1.Theme
 */
export enum Theme {
  /**
   * @generated from enum value: THEME_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: THEME_SYSTEM = 1;
   */
  SYSTEM = 1,

  /**
   * @generated from enum value: THEME_LIGHT = 2;
   */
  LIGHT = 2,

  /**
   * @generated from enum value: THEME_DARK = 3;
   */
  DARK = 3,
}

/**
 * Describes the enum bffuser.v1.Theme.
 */
export const ThemeSchema: GenEnum<Theme> = /*@__PURE__*/
  enumDesc(file_bffuser_v1_setting_model, 0);

/**
 * MonitoringUnit controls the unit displayed in dashboard monitoring views.
 * Mirrors internalapi.v1.MonitoringUnit; the BFF handler converts between them.
 *
 * @generated from enum bffuser.v1.MonitoringUnit
 */
export enum MonitoringUnit {
  /**
   * @generated from enum value: MONITORING_UNIT_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: MONITORING_UNIT_MWH = 1;
   */
  MWH = 1,

  /**
   * @generated from enum value: MONITORING_UNIT_KWH = 2;
   */
  KWH = 2,
}

/**
 * Describes the enum bffuser.v1.MonitoringUnit.
 */
export const MonitoringUnitSchema: GenEnum<MonitoringUnit> = /*@__PURE__*/
  enumDesc(file_bffuser_v1_setting_model, 1);

/**
 * OrderBookColumnOrder controls which side of the order book (sell / buy) is
 * placed on the left in the intraday bidding board screen (AC-SPS-032 / AC-SPS-033).
 * Mirrors internalapi.v1.OrderBookColumnOrder; the BFF handler converts between them.
 *
 * @generated from enum bffuser.v1.OrderBookColumnOrder
 */
export enum OrderBookColumnOrder {
  /**
   * @generated from enum value: ORDER_BOOK_COLUMN_ORDER_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * sell left, buy right (default)
   *
   * @generated from enum value: ORDER_BOOK_COLUMN_ORDER_SELL_LEFT = 1;
   */
  SELL_LEFT = 1,

  /**
   * buy left, sell right
   *
   * @generated from enum value: ORDER_BOOK_COLUMN_ORDER_BUY_LEFT = 2;
   */
  BUY_LEFT = 2,
}

/**
 * Describes the enum bffuser.v1.OrderBookColumnOrder.
 */
export const OrderBookColumnOrderSchema: GenEnum<OrderBookColumnOrder> = /*@__PURE__*/
  enumDesc(file_bffuser_v1_setting_model, 2);

/**
 * GenerationSourceTypeForSetting is the ordered stack display classification
 * for the settings screen.
 * Mirrors internalapi.v1.GenerationSourceTypeForSetting; the BFF handler
 * converts between them.
 *
 * @generated from enum bffuser.v1.GenerationSourceTypeForSetting
 */
export enum GenerationSourceTypeForSetting {
  /**
   * @generated from enum value: GENERATION_SOURCE_TYPE_FOR_SETTING_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: GENERATION_SOURCE_TYPE_FOR_SETTING_COAL_THERMAL = 1;
   */
  COAL_THERMAL = 1,

  /**
   * @generated from enum value: GENERATION_SOURCE_TYPE_FOR_SETTING_GAS_THERMAL = 2;
   */
  GAS_THERMAL = 2,

  /**
   * @generated from enum value: GENERATION_SOURCE_TYPE_FOR_SETTING_OIL_THERMAL = 3;
   */
  OIL_THERMAL = 3,

  /**
   * @generated from enum value: GENERATION_SOURCE_TYPE_FOR_SETTING_NUCLEAR = 4;
   */
  NUCLEAR = 4,

  /**
   * @generated from enum value: GENERATION_SOURCE_TYPE_FOR_SETTING_SOLAR = 5;
   */
  SOLAR = 5,

  /**
   * @generated from enum value: GENERATION_SOURCE_TYPE_FOR_SETTING_WIND = 6;
   */
  WIND = 6,

  /**
   * @generated from enum value: GENERATION_SOURCE_TYPE_FOR_SETTING_HYDRO = 7;
   */
  HYDRO = 7,

  /**
   * @generated from enum value: GENERATION_SOURCE_TYPE_FOR_SETTING_GEOTHERMAL = 8;
   */
  GEOTHERMAL = 8,

  /**
   * @generated from enum value: GENERATION_SOURCE_TYPE_FOR_SETTING_OTHER = 9;
   */
  OTHER = 9,
}

/**
 * Describes the enum bffuser.v1.GenerationSourceTypeForSetting.
 */
export const GenerationSourceTypeForSettingSchema: GenEnum<GenerationSourceTypeForSetting> = /*@__PURE__*/
  enumDesc(file_bffuser_v1_setting_model, 3);

